/**
 *
 * Asynchronously loads the component for UserAcceptProgramInvite
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/UserAcceptProgramInvite/loadable.js